import { useMutation } from '@tanstack/react-query';
import API from 'api/API';

export const useOrderMutation = () => {
  return useMutation({
    mutationFn: async (orderRecordId: Parameters<typeof API.orders.getOrder>[0]) => API.orders.getOrder(orderRecordId),
  });
};
